import React, { useEffect, useState } from 'react';
import {
  Button,
  Descriptions,
  Form,
  Input,
  Modal,
  Select,
  message,
} from 'antd';
import { IoMdAdd } from 'react-icons/io';
import axios from 'axios';
import { Option } from 'antd/es/mentions';

const AddFeeDetails = ({ onChange, value }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [caseOptions, setcaseOptions] = useState([]);

  const fetchcaseOptions = async () => {
    try {
      const response = await axios.get(
        'http://admin.defconinnovations.com/advocateapi/cases/',
        {
          headers: {
            Authorization: `Token c404c955a08ca1779628c914e7692927074af875`,
            'Content-Type': 'application/json',
          },
        }
      );
      setcaseOptions(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    /* fetchcaseOptions(); */
  }, []); // Fetch data when the component mounts

  /* useEffect(() => {
    console.log('Updated caseOptions:', caseOptions);
  }, [caseOptions]); */
  const handleSubmit = async values => {
    setLoading(true);
    /* try {
      const response = await axios.post(
        'http://admin.defconinnovations.com/advocateapi/case-fees/',
        {
          amount: values.amount,
          case: values.case,
          description: values.description,
        },
        {
          headers: {
            Authorization: `Token c404c955a08ca1779628c914e7692927074af875`,
          },
        }
      );
      alert('case-Fees added successfully');
      console.log('Response data:', response.data);
      setOpen(false);
      form.resetFields();
    } catch (error) {
      console.error(
        'Error posting fees:',
        error.response?.data || error.message
      );
      message.error(
        'Failed to add fee: ' +
          (error.response?.data?.detail || 'Unknown error')
      );
    } finally {
      setLoading(false);
    } */
  };
  return (
    <>
      <Button icon={<IoMdAdd />} type="primary" onClick={() => setOpen(true)}>
        Add Fees
      </Button>
      <Modal
        open={open}
        caseOptions="Add Fees"
        onCancel={() => setOpen(false)}
        onOk={() => form.submit()}
        okText="Submit"
        confirmLoading={loading}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          name="add_fee_form"
          onFinish={handleSubmit}
          preserve={false}
        >
          <Form.Item
            name="amount"
            label="Amount"
            rules={[
              {
                required: true,
                message: 'Please enter the fee amount',
              },
            ]}
          >
            <Input type="number" placeholder="Enter fee amount" />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[
              {
                required: true,
                message: 'Please enter Your description',
              },
            ]}
          >
            <Input type="text" placeholder="Enter Case Description" />
          </Form.Item>
          <Form.Item
            name="case"
            label="Case ID"
            rules={[
              {
                required: true,
                message: 'Please enter the case ID',
              },
            ]}
          >
            <Select
              placeholder="Select a client"
              onChange={onChange}
              value={value}
              style={{ width: '100%' }}
            >
              {caseOptions.map(option => (
                <Option key={option.id} value={option.id}>
                  {option.title}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddFeeDetails;
